import { render, staticRenderFns } from "./CardFinancialDemonstrations.vue?vue&type=template&id=4f4e5c64&"
import script from "./CardFinancialDemonstrations.vue?vue&type=script&lang=js&"
export * from "./CardFinancialDemonstrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports